const palette = {
  primary:  "#00205C",
  primary_dark: "#011740",
  primary_light: "#3e8cff",

  navy: '#04014d',

  secondary: "#5246a2",
  secondary_light: "#6C5DD3",
  dark: "#0b5e9c",
  info: "#74b9ff",
  info_light: "#b4d5f7",
  success: "#70D44B",
  danger: "#d8204e",
  warning: "#ffbe36",
  warning_dark: "#ffa25f",
  orange: "#f9690e",
  coral: "#ff7f50",
  purple: "#5b0589",
  white: "#ffffff",
  
  light_grey: "rgb(223, 228, 234)",
  lighter_grey: "#eee",
  lightest_grey: "#f5f5f5",
  grey: "#7f8191",
  dark: "#444444",
  dark_grey: "#8d8e90",
  darker_grey: "#1c1d21",
  black: "#000000",
  transparent: 'transparent'
};

export default palette;
